import React from 'react'
import moment from 'moment'
import api from '../../apiClient/v1'
//Componentes
import { TablaDistancias } from './TablaDistancias.jsx'
import BlackBoxDistancia from './BlackBoxDistancia'

let PropTypes = React.PropTypes
moment.locale('es')

export class MantenedorDistancias extends React.Component{
    constructor(props){
        super(props)
        this.blackbox = new BlackBoxDistancia()
        this.getCuidadesZonas = this.getCuidadesZonas.bind(this)
        this.state = {
            comunas: [],
            comunasRow: [],
            comunasHeader: [],
            zonas: [],
            filtrosComunas: [],
            semanaSeleccionada: '',
            numero_semana: 0
        }
        this.onInputChange=(key, evt)=>{
            console.log(evt.target.value)
            this.setState({
                [key]: evt.target.value
            })
        }
        this.onSelectZona=(index)=>{
            let zonas = this.state.zonas
            zonas[index].seleccionado = zonas[index].seleccionado? 0 : 1
            this.setState({
                zonas,
            },()=>this.getCuidadesZonas())
        }
        this.actualizarFiltro=(nombreFiltro, filtro)=>{
            this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
            this.setState(this.blackbox.getListaFiltrada())
        }
    }
    getChildContext(){
        return{
            guardaDestino:(idComunaDistancia, idComunaOrigen, idComunaDestino, valor)=>{
                console.log('guardaDestinos')
                api.fondos().guardaDestinos(idComunaDistancia, idComunaOrigen, idComunaDestino, valor)
                    .then(resp=>{
                        console.log(resp)
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
    }
    componentWillMount(){
        api.otros.zonas()
            .then(zonas=>{
                this.setState({zonas: zonas})
            })
            .catch(err=>{
                console.log(err)
            })
    }
    onWeekChange(evt){
        this.setState({
            semanaSeleccionada: evt.target.value,
            numero_semana: evt.target.value.substring(6,8)
        },()=>this.getLideresSemana())
    }
    getCuidadesZonas(){
        var zonasSeleccionadas = []
        let i = 0
        this.blackbox.reset()
        this.setState({
            comunasRow: [],
            semanaSeleccionada: '0000-W00',
            comunasHeader: []
        })

        this.state.zonas.forEach(zona => {
            if(zona.seleccionado){
                zonasSeleccionadas[i] = zona.idZona
                i++
            }
        });
            api.otros.comunasZonas(zonasSeleccionadas)
                .then(comunas=>{
                    comunas.forEach(comuna=>this.blackbox.add(comuna))
                    this.blackbox.ordenar()
                    this.setState(this.blackbox.getListaFiltrada())
                    this.setState({
                        comunasHeader: comunas
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
    }
    getLideresSemana(){
        api.otros.zonas()
            .then(zonas=>{
                this.setState({
                    zonas: zonas,
                    comunasRow: [],
                    comunasHeader: []
                })
            })
            .catch(err=>{
                console.log(err)
            })
        this.blackbox.reset()

        if(this.state.numero_semana){
            let fechaInicio = moment().day("Lunes").week(this.state.numero_semana).format('YYYY-MM-DD')
            let fechaFin = moment().day("Domingo").week(this.state.numero_semana).format('YYYY-MM-DD') 

            api.fondos().getCiudadesInventarios(fechaInicio, fechaFin)
                .then(comunas=>{
                    comunas.forEach(comuna=>this.blackbox.add(comuna))
                    this.blackbox.ordenar()
                    this.setState(this.blackbox.getListaFiltrada())
                    this.setState({
                        comunasHeader: comunas
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
        }    
    }
    render() {
        return (
            <div>
                <div className="col-md-12 col-xs-12 form-group">
                    <h3>Mantenedor Distancias</h3>
                </div>
                <div className="col-md-6">
                    <div className="panel panel-info">
                        <div className="panel-heading"><b>Buscar Por Zonas</b></div>
                        <div className="panel-body">
                            <div className="col-md-12">
                                <div className="col-md-12">
                                    {this.state.zonas.map((zona, index)=>{
                                        return <div className="col-md-3" key={zona.idZona}>
                                            <label>
                                                <input type="checkbox" 
                                                    checked={zona.seleccionado} 
                                                    title={zona.nombre} 
                                                    onChange={this.onSelectZona.bind(this, index)}/> 
                                                {zona.nombre}
                                            </label>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="panel panel-info">
                        <div className="panel-heading"><b>Buscar por Semana de inventario</b></div>
                        <div className="panel-body">
                            <div className={'col-md-6 form-group '}>
                                <input type="week" className={"form-control"} 
                                    value={this.state.semanaSeleccionada} 
                                    onChange={this.onWeekChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-xs-12">
                    <div className="row">
                        <TablaDistancias
                            filtros={this.state.filtrosComunas}
                            actualizarFiltro={this.actualizarFiltro.bind(this)}
                            comunasHeader={this.state.comunasHeader}
                            comunasRow={this.state.comunasRow}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
MantenedorDistancias.childContextTypes = {
    guardaDestino: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/admin/distancias/MantenedorDistancias.jsx